import React, { Suspense } from "react";
import Preloader from "../elements/Preloader";
import HeaderOne from "../components/HeaderOne";
import Breadcrumb from "../components/Breadcrumb";
import AboutTwo from "../components/AboutTwo";
import FooterThree from "../components/FooterThree";
import WhoWeAreOne from "../components/WhoWeAreOne";

const About = () => {
  return (
    <>
      <Suspense fallback={<Preloader />}>
        <HeaderOne />
        <main>
          <Breadcrumb title="Hakkımızda" />
          <AboutTwo />
          <WhoWeAreOne />
        
        </main>
        <FooterThree />
      </Suspense>
    </>
  );
};

export default About;
